import portfolioRoutes from "portfolio/routes";
import bulkPdfExportRoutes from "bulk-pdf-export/routes";
import classroomRoutes from "classroom/routes";
import actionplanRoutes from "actionplan/routes";

export const modules = Object.values(
  import.meta.glob("./*.{js,ts}", { eager: true, import: "default" }),
).reduce((result, current) => {
  if (typeof current === "function") {
    current().map((route) => result.push(route));
    return result;
  }

  current.map((route) => result.push(route));

  return result;
}, []);

// Add domain routes
portfolioRoutes.forEach((route) => modules.push(route));
bulkPdfExportRoutes.forEach((route) => modules.push(route));
classroomRoutes.forEach((route) => modules.push(route));
actionplanRoutes.forEach((route) => modules.push(route));

export default modules;
